import { AssetDto } from '@nusign/picflow-backend-types';
import { Rect } from '../classes/rect.class';
import { assetSideMenuSize } from '../consts';
import { getAssetDimentions } from '../gallery/lib/get-asset-dimentions';
import { devicePixelRatio } from './device-pixel-ratio';

const getDataBackup = () => {
  return { width: 250 * devicePixelRatio(), height: 250 * devicePixelRatio() };
};

const getFullWindowHeight = () => {
  // cant use window.innerHeight because that doesn't work when the keyboard is open on IOS
  const outer = document.createElement('div');
  outer.style.display = 'block';
  outer.style.visibility = 'hidden';
  outer.style.height = '100dvh';
  document.body.appendChild(outer);
  const height = outer.clientHeight;
  outer.parentNode.removeChild(outer);
  return height;
};

export const GetBounds = (
  offsetScale: number,
  scale: number,
  sideMenuOpen: boolean,
  asset: AssetDto,
  offsetX: number,
  offsetY: number,
  isDesktop: boolean
): Rect => {
  const _scale = offsetScale * scale;

  const left = asset.type === 'document' && isDesktop ? 160 : 0;

  const containerWidth = window.innerWidth - (sideMenuOpen && isDesktop ? assetSideMenuSize : 0) - left;
  const containerHeight = getFullWindowHeight() * (!isDesktop && sideMenuOpen ? 0.3 : 1);

  const { width, height } = getAssetDimentions(asset.version_data, getDataBackup());
  const bounds = new Rect(left, 0, width * _scale, height * _scale);

  bounds.x += containerWidth / 2;
  bounds.x -= bounds.width / 2;
  bounds.y += containerHeight / 2;
  bounds.y -= bounds.height / 2;
  bounds.x += offsetX * scale;
  bounds.y += offsetY * scale;

  return bounds;
};
